import { StyleSheet } from 'react-native';

import { THEME } from '../../common';

const { SPACE } = THEME;

export default StyleSheet.create({
  container: {
    marginTop: SPACE.XXS,
    paddingLeft: 0,
    maxWidth: '100%',
  },
});
